import { graphql } from 'gql';

export const getWorkOrderOther = graphql(`
    query uerWorkOrderOtherCostSelectionList(
        $workOrderId: Long!
        $constructionTypeId: Int!
        $where: WorkOrderOtherCostItemFilterInput
    ) {
        uerWorkOrderOtherCostSelectionList(
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            where: $where
        ) {
            otherCost {
                contractOtherCostId
                catalogOtherCostTypeId
                catalogOtherCostType {
                    canDelete
                    isSystem
                    id
                    uniqueId
                    name
                }
                name
                calculatingType
                calculatingTypeValue
                chapter
                section
                status
            }
            workOrderObjects {
                workOrderRootObjectId
                hasActsKC2
                hasActualCost
                isActKC2Cost
                contractObjectId
                name
                isIncluded
                canAddOther
                canRemoveOther
                rationale
            }
            seasonLimits {
                workOrderSeasonId
                workOrderSeasonYear
                includedCost
                isIncluded
                planCost
                actualCost
                remainderCost
                deviation
            }
            hasSeasonLimits
        }
    }
`);

export const uerUpdateWorkOrderOtherCostItemsGql = graphql(`
    mutation uerUpdateWorkOrderOtherCostItems(
        $workOrderId: Long!
        $constructionTypeId: Int!
        $otherPriceInputs: [UpdateWorkOrderOtherPriceItemInput!]!
    ) {
        uerUpdateWorkOrderOtherCostItems(
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            otherPriceInputs: $otherPriceInputs
        ) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const addWorkOrderOtherCost = graphql(`
    mutation uerAddWorkOrderOtherCost($workOrderId: Long!, $otherCostInput: UpdateWorkOrderOtherCostInput!) {
        uerAddWorkOrderOtherCost(workOrderId: $workOrderId, otherCostInput: $otherCostInput) {
            data {
                id
                name
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const workOrderOthersForActKC2 = graphql(`
    query uerWorkOrderOthersForActKC2($workOrderObjectId: Long!) {
        uerWorkOrderOthersForActKC2(workOrderObjectId: $workOrderObjectId) {
            hasSeasonLimit
            contractOtherCostId
            name
            calculatingType
            calculatingTypeValue
            chapter
            section
            status
            limits {
                season {
                    year
                    id
                }
                costLimit
                totalRemainderCost
                deviation
            }
        }
    }
`);

export const addOtherToActKC2 = graphql(`
    mutation uerAddOtherCostToActKC2($workOrderObjectId: Long!, $otherInputs: [UerOtherCostInput!]!) {
        uerAddOtherCostToActKC2(otherInputs: $otherInputs, workOrderObjectId: $workOrderObjectId) {
            data
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
            message
        }
    }
`);
